import store from '@/store';
import M_optionItem from '@/models/optionItem';

export default {
  setDisplayText(rawData, isShowOptionName, isSubOption) {
    const _selectingLocale = store.state.locale.selectingLocale;
    let resultText = '';
    const {risk_level, has_remark, locales} = rawData;
    if (isShowOptionName || isSubOption) resultText += `${locales[_selectingLocale].name} : `;
    if (risk_level === null) {
      resultText += '無設定風險';
    } else {
      const tarRisk = M_optionItem.fields.optionItem.fields.risk_level.items.find(item => item.value == risk_level);
      resultText += tarRisk
        ? tarRisk.text
        : risk_level;
    }
    if (
      has_remark &&
      (
        (Array.isArray(has_remark) && has_remark.length) ||
        (typeof has_remark === 'number' && has_remark === 1)
      )
    ) resultText += ` / 選答時要求必填備註`;
    return resultText;
  }
}